import { optionalRouteSearchString } from "../../shared/web/route-search.ts";

export type ApprovalListSearch = {
  search?: string;
  team?: string;
};

export const approvalListSearch = (search: Record<string, unknown>): ApprovalListSearch => ({
  search: optionalRouteSearchString(search.search),
  team: optionalRouteSearchString(search.team),
});
